import { Injectable } from '@angular/core';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser/ngx';
import { ApiService } from './api.service';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { Platform } from '@ionic/angular';
import { Router } from '@angular/router';
import { PdfService } from './pdf.service';
import { AllInOneSDK } from '@ionic-native/all-in-one-sdk/ngx';
import { HandlerService } from './handler.service';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  paytm: any = {};code; payDetails: any;mode;payMode; appBrowser;browsewindow;  RazorpayCheckout:any;paymentResponse;value;
  paymentMode: any = [{ id: 9, name: "CC" },
  { id: 10, name: "DC" },{ id: 11, name: "NB" },{id: 12, name: "UPI"},{id: 13, name: "PPI"}];
  paytmPopUp:boolean = false;paymentError:any;
  constructor(private browser: InAppBrowser, private service: ApiService,
    private pdf: PdfService,
    public handler: HandlerService,
    private platform: Platform, private router: Router,
    private splash: SplashScreen,
    private allInOneSDK : AllInOneSDK) {
  }

  
  setPaymentParamters(data, id) {
    this.payDetails = data;
    let mobile = data.contactNbrMob;
    Object.assign(this.paytm, {
      CUST_ID: data.requestorId,
      MOBILE_NO: mobile, INDUSTRY_TYPE_ID: "Retail",   
      CHANNEL_ID: "WAP",
      EMAIL: "mconnectz@mconnectz.com",
      TXN_AMOUNT: data.payTotal,
      WEBSITE: "WEBSTAGING"
    })
    if(data.subscriptionInd==true){
      Object.assign(this.paytm,{ORDER_ID: data.customerInvoiceId})
    }else{
      Object.assign(this.paytm,{ORDER_ID: data.id})
    }
         
    if(data.subscriptionInd==true){
    if (id == 1){
      Object.assign(this.paytm, { MID: "BxyWML51492272417758", CALLBACK_URL: 'http://3.209.13.42:8080/newyess/invoices/confirmPayment'});

      if(this.platform.is('android'))
      Object.assign(this.paytm,{paytmurl:'https://securegw-stage.paytm.in/order/process'})
      
    }
    else{
      Object.assign(this.paytm, { MID: "MISSIN13426017797916", CALLBACK_URL: 'https://app.oteller.in/newyess/invoices/confirmPayment'});
      if(this.platform.is('android'))
      Object.assign(this.paytm,{paytmurl:'https://securegw.paytm.in/order/process'})
    }
  }else{
    if (id == 1){
      Object.assign(this.paytm, { MID: "BxyWML51492272417758", CALLBACK_URL: 'http://3.209.13.42:8080/newyess/orders/confirmPayment'});

      if(this.platform.is('android'))
      Object.assign(this.paytm,{paytmurl:'https://securegw-stage.paytm.in/order/process'})
      
    }
    else{
      Object.assign(this.paytm, { MID: "MISSIN13426017797916", CALLBACK_URL: 'https://app.oteller.in/newyess/orders/confirmPayment'});
      if(this.platform.is('android'))
      Object.assign(this.paytm,{paytmurl:'https://securegw.paytm.in/order/process'})
    }
  }
  }
  startPayment() {
    if(this.payDetails.subscriptionInd==true){
      this.pdf.loader=true;
      let mobile = this.payDetails.contactNbrMob;
      let post = {
        id: this.payDetails.customerInvoiceId,
        payerId: this.payDetails.requestorId,
        payTotal: this.payDetails.payTotal,
        payer: {
          contactNbrMob: mobile, 
          emailId:mobile+'@gmail.com',   
          id: this.payDetails.requestorId
        },
        paymtCallBackUrl: this.paytm.CALLBACK_URL
      }
      this.service.getPaytmHash(post).subscribe(res => {
        this.pdf.loader=false;
      }, err => {
         this.pdf.loader=false;
        this.paytm['CHECKSUMHASH'] = err.error.text;
        sessionStorage.setItem('paydata', JSON.stringify(this.paytm))
        setTimeout(() => {
          if (this.platform.is('android')) {
            this.splash.hide()
            const options: InAppBrowserOptions = {
              location: "yes",
              hideurlbar: 'yes',
              closebuttoncaption: "Close",
              hidenavigationbuttons: "yes",
              hardwareback: 'no'
            }
            var pageContent = '<html>' +
              '<head>' +
              '<title>Merchant Check Out Page</title>' +
              '<body>' +
              '<centre><h1>Please do not refresh this page...</h1></centre>' +
              '<form method="post" action="'+this.paytm.paytmurl+'" name="paytm">' +
              '<table border="1">' +
              ' <tbody>' +
              '<input type="hidden" id="mid" name="MID" value="' + this.paytm.MID + '">' +
              '<input type="hidden"  name="WEBSITE" value="' + this.paytm.WEBSITE + '">' +
              '<input type="hidden" name="ORDER_ID" value="' + this.paytm.ORDER_ID + '">' +
              '<input type="hidden" name="CUST_ID" value="' + this.paytm.CUST_ID + '">' +
              '<input type="hidden" name="MOBILE_NO" value="' + this.paytm.MOBILE_NO + '">' +
              '<input type="hidden" name="EMAIL" value="' + this.paytm.EMAIL + '">' +
              '<input type="hidden" name="INDUSTRY_TYPE_ID" value="' + this.paytm.INDUSTRY_TYPE_ID + '">' +
              '<input type="hidden" name="CHANNEL_ID"value="' + this.paytm.CHANNEL_ID + '">' +
              '<input type="hidden" name="TXN_AMOUNT"value="' + this.paytm.TXN_AMOUNT + '">' +
              '<input type="hidden" name="CALLBACK_URL"value="' + this.paytm.CALLBACK_URL + '">' +
              '<input type="hidden" id="checksum" name="CHECKSUMHASH"value="' + this.paytm.CHECKSUMHASH + '">' +
              '</tbody>' +
              '</table>' +
              ' <script type="text/javascript">' +
              'setTimeout(() => {' +
              'document.paytm.submit()' +
              '}, 5000);' +
              '</script>' +
              '</form>' +
              '</body></head></html>'
            var pageContentUrl = 'data:text/html;base64,' + btoa(pageContent);
            this.appBrowser = this.browser.create(pageContentUrl, '_blank', options);
            this.appBrowser.on('exit').subscribe(res => {
              this.router.navigateByUrl('bookservice1')
            })
            this.appBrowser.on('loadstop').subscribe(res => {
              if (res.url.includes('confirmPayment')) {
                this.checkForSucess(2000)
              }
            })
          }
          else {
           this.browsewindow= window.open('assets/paytm.html','_blank', 'height=screen.height,width=screen.width')
           this.checkBrowserUrl(5000)
          }
        })
      })
    
    }else{
      this.pdf.loader=true;
      let mobile = this.payDetails.contactNbrMob;
      let post = {
        id: this.payDetails.id,
        customerId: this.payDetails.requestorId,
        paymtAmt: this.payDetails.payTotal,
        customer: {
          contactNbrMob: mobile, 
          emailId:mobile+'@gmail.com',   
          userId: this.payDetails.requestorId
        },
        paymtCallBackUrl: this.paytm.CALLBACK_URL
      }
      this.service.getPaytmHashOrder(post).subscribe(res => {
        this.pdf.loader=false;
      }, err => {
         this.pdf.loader=false;
        this.paytm['CHECKSUMHASH'] = err.error.text;
        sessionStorage.setItem('paydata', JSON.stringify(this.paytm))
        setTimeout(() => {
          if (this.platform.is('android')) {
            this.splash.hide()
            const options: InAppBrowserOptions = {
              location: "yes",
              hideurlbar: 'yes',
              closebuttoncaption: "Close",
              hidenavigationbuttons: "yes",
              hardwareback: 'no'
            }
            var pageContent = '<html>' +
              '<head>' +
              '<title>Merchant Check Out Page</title>' +
              '<body>' +
              '<centre><h1>Please do not refresh this page...</h1></centre>' +
              '<form method="post" action="'+this.paytm.paytmurl+'" name="paytm">' +
              '<table border="1">' +
              ' <tbody>' +
              '<input type="hidden" id="mid" name="MID" value="' + this.paytm.MID + '">' +
              '<input type="hidden"  name="WEBSITE" value="' + this.paytm.WEBSITE + '">' +
              '<input type="hidden" name="ORDER_ID" value="' + this.paytm.ORDER_ID + '">' +
              '<input type="hidden" name="CUST_ID" value="' + this.paytm.CUST_ID + '">' +
              '<input type="hidden" name="MOBILE_NO" value="' + this.paytm.MOBILE_NO + '">' +
              '<input type="hidden" name="EMAIL" value="' + this.paytm.EMAIL + '">' +
              '<input type="hidden" name="INDUSTRY_TYPE_ID" value="' + this.paytm.INDUSTRY_TYPE_ID + '">' +
              '<input type="hidden" name="CHANNEL_ID"value="' + this.paytm.CHANNEL_ID + '">' +
              '<input type="hidden" name="TXN_AMOUNT"value="' + this.paytm.TXN_AMOUNT + '">' +
              '<input type="hidden" name="CALLBACK_URL"value="' + this.paytm.CALLBACK_URL + '">' +
              '<input type="hidden" id="checksum" name="CHECKSUMHASH"value="' + this.paytm.CHECKSUMHASH + '">' +
              '</tbody>' +
              '</table>' +
              ' <script type="text/javascript">' +
              'setTimeout(() => {' +
              'document.paytm.submit()' +
              '}, 5000);' +
              '</script>' +
              '</form>' +
              '</body></head></html>'
            var pageContentUrl = 'data:text/html;base64,' + btoa(pageContent);
            this.appBrowser = this.browser.create(pageContentUrl, '_blank', options);
            this.appBrowser.on('exit').subscribe(res => {
              this.router.navigateByUrl('bookservice1')
            })
            this.appBrowser.on('loadstop').subscribe(res => {
              if (res.url.includes('confirmPayment')) {
                this.checkForSucess(2000)
              }
            })
          }
          else {
           this.browsewindow= window.open('assets/paytm.html','_blank', 'height=screen.height,width=screen.width')
           this.checkBrowserUrl(5000)
          }
        })
      })
    
    }   
  }

  checkForSucess(dur) {
    let obj = this
    setTimeout(() => {
      this.appBrowser.executeScript({ code: "localStorage.getItem('success')" }, function (values) {
        if (values[0] =='true'){
          setTimeout(() => {
            obj.appBrowser.close();
          }, 5000);
        }
        else
          obj.checkForSucess(2000)
      })
    }, dur);
  }

  checkBrowserUrl(dur){
   setTimeout(() => {
    if(this.browsewindow.location.href.includes("invoices/confirmPayment")){
   if(this.browsewindow.localStorage.success){
     setTimeout(() => {
      this.browsewindow.close();
      this.routeback()
      }, 5000);
    }
   }
    else
    this.checkBrowserUrl(2000)
   }, dur);
  }
  routeback(){
    this.router.navigateByUrl('bookservice1')
  }

//   payWithRazorpay(data, id){
//     var options = {
//     description: 'Credits towards consultation',
//     image: 'https://i.imgur.com/3g7nmJC.png',
//     order_id: data.id ,
//     currency: 'INR',
//     key:'rzp_test_TogNwx4QKhszUK',
//     amount:data.payTotal,
//     name: 'Missing Connectz Technology Solution Pvt Ltd',
//     theme: {
//       color: '#3399cc'
//         }
//     }
// var successCallback = function(success) {
// alert('payment_id: ' + success.razorpay_payment_id)
// var orderId = success.razorpay_order_id
// var signature = success.razorpay_signature
// }
// var cancelCallback = function(error) {
// alert(error.description + ' (Error '+error.code+')')
// }
// this.RazorpayCheckout.on('payment.success', successCallback)
// this.RazorpayCheckout.on('payment.cancel', cancelCallback)
// this.RazorpayCheckout.open(options)
// }

paytmm(){
  this.handler.loader = true;
  this.pdf.loader=true;
  if(window['url'].includes('3.209.13.42')){
    this.value = 1; 
  }else{
    this.value = 2;
  }
  if(this.value==1){
    // if(this.payDetails.subscriptionInd==true){
    //   Object.assign(this.payDetails, { MID: "BxyWML51492272417758", isStaging:true,CALLBACK_URL: 'http://3.209.13.42:8080/newyess/invoices/confirmPayment'});
    // }else{
      Object.assign(this.payDetails, { MID: "BxyWML51492272417758",isStaging:true, CALLBACK_URL: 'http://3.209.13.42:8080/newyess/orders/confirmPayment'});

    // }
    }else{
      // if(this.payDetails.subscriptionInd==true){
      //   Object.assign(this.payDetails, { MID: "MISSIN13426017797916",isStaging:false, CALLBACK_URL: 'https://app.oteller.in/newyess/invoices/confirmPayment'});
      // }else{
        Object.assign(this.payDetails, { MID: "MISSIN13426017797916",isStaging:false, CALLBACK_URL: 'https://securegw.paytm.in/theia/paytmCallback?ORDER_ID='+this.payDetails.id});
      // }
    }
   
  let mobile = this.payDetails.contactNbrMob;
  // if(this.payDetails.subscriptionInd==true){
  //   let post = {
  //     id: this.payDetails.customerInvoiceId,
  //     payerId: this.payDetails.requestorId,
  //     payTotal: "1.00",
  //     customer: {
  //       contactNbrMob: mobile,   
  //       userId: this.payDetails.requestorId
  //     },
  //     paymtCallBackUrl:this.payDetails.CALLBACK_URL
  //   }
  //   this.service.getPaytmHash(post).subscribe(res => {
  //     this.paymentResponse=res; 
  //   
  //     var paymentIntent = { mid : this.payDetails.MID, 
  //       orderId:this.payDetails.id.toString(), 
  //       txnToken: this.paymentResponse.body.txnToken, 
  //       amount: "1.00", 
  //       isStaging: this.payDetails.isStaging, 
  //       callbackUrl:this.payDetails.CALLBACK_URL,
  //       restrictAppInvoke:false }
  //     
  //       this.allInOneSDK.startTransaction(paymentIntent).then(
  //           resp => {
  //             
  //             var a:any = JSON.parse(resp.response);
  //             var b = JSON.parse(a.response);
  //             var c = b.RESPCODE;
  //             this.code = b.TXNID;
  //             this.mode = b.PAYMENTMODE;
  //             this.handler.payObj = b;
  //             console.log( this.handler.payObj , "handler.payobj")
  //             if(c == "01"){
  //               this.recordSubsPaymentSuccess(this.code,this.mode);
  //             }else if(c == "402" || c == "400"){
  //               this.recordSubsPaymentPending(this.code,this.mode);
  //             }
  //             else{
  //               this.router.navigate(['/failure'])
  //             }
  //           }).catch(error => {
  //             this.handler.loader = false;
  //             alert("Choose Different Payment Method")
  //             this.handler.loader=false;
  //           })
  //   }, err => {
  //     this.handler.loader = false;
  //   })
  // }else{
    let post1 = {
      id: this.payDetails.id,
      customerId: this.payDetails.requestorId,
      paymtAmt: this.payDetails.payTotal,
      customer: {
        contactNbrMob: mobile,   
        userId: this.payDetails.requestorId
      },
      paymtCallBackUrl:this.payDetails.CALLBACK_URL
    }
    this.service.getPaytmHashOrder(post1).subscribe(res => {
      this.paymentResponse=res;
      var paymentIntent = { mid : this.payDetails.MID, 
        orderId:this.payDetails.id.toString(), 
        txnToken: this.paymentResponse.body.txnToken, 
        amount: this.payDetails.payTotal, 
        isStaging:  this.payDetails.isStaging, 
        callbackUrl:this.payDetails.CALLBACK_URL,
        restrictAppInvoke:false }
        this.allInOneSDK.startTransaction(paymentIntent).then(
          resp => {
            var a:any = JSON.parse(resp.response);
            if(a.response != null || a.response != undefined){
              var b = JSON.parse(a.response);
              var c = b.RESPCODE;
              this.code = b.TXNID;
              this.mode = b.PAYMENTMODE;
              this.handler.payObj = b;
            }else{
              var c = a.RESPCODE;
              this.code = a.TXNID;
              this.mode = a.PAYMENTMODE;
              this.handler.payObj = a;
            }
            if(c == "01"){
              this.recordOrderPaymentSuccess(this.code,this.mode);
            }else if(c == "402" || c == "400"){
              this.recordOrderPaymentPending(this.code,this.mode);
            }
            else{
              this.router.navigate(['/failure'])
            }
          })
          .catch(error => {
            alert("Choose Different Payment Method");
            this.handler.loader=false;
          })
    }, err => {
      this.paymentError = err.error.msg;
      this.handler.loader=false; 
      this.paytmPopUp = true;    
    })
  
}


recordSubsPaymentSuccess(data,data1){
  this.paymentMode.map(dat=>{
    if(dat.name==data1){
      this.payMode=dat.id;
    }
  })
  var post ={
   cost: sessionStorage.getItem('PayCost'),
   paymentMode: this.payMode,      
   paymentRcvdBy:'23874' ,  
   paymentStatus:2, 
   month:sessionStorage.getItem('month'),
   year:sessionStorage.getItem('year'),      
   referenceId:data
 }        
this.service.postSubsPaymentDetails(this.payDetails.id,post).subscribe(res1=>{
  this.handler.loader = false;
  this.handler.res("Payment is successfull!!!");
  this.router.navigate(['/success'])
   
})
}

recordSubsPaymentPending(data,data1){
  this.paymentMode.map(dat=>{
    if(dat.name==data1){
      this.payMode=dat.id;
    }
  })
  var post ={
   cost: sessionStorage.getItem('PayCost'),
   paymentMode: this.payMode,      
   paymentRcvdBy:'23874' ,  
   paymentStatus:4, 
   month:sessionStorage.getItem('month'),
   year:sessionStorage.getItem('year'),      
   referenceId:data
 }        
this.service.postSubsPaymentDetails(this.payDetails.id,post).subscribe(res1=>{
  this.handler.loader = false;
  this.handler.res("Payment is Pending!!!");
  this.router.navigate(['/pending'])
})
}

recordOrderPaymentSuccess(data,data1){
this.paymentMode.map(dat=>{
  if(dat.name==data1){
    this.payMode=dat.id;
  }
})
var post1 ={
 PaymtAmt: sessionStorage.getItem('PayCost'),
 PaymtMode:this.payMode,
 PaymtRef:data,
 paymtStatus:2
}     
this.service.postOrderPaymentDetails(this.payDetails.id,post1).subscribe(res1=>{
 this.handler.res("Payment is successfull!!! Please wait to be redirected to app automatically... ");
 this.complete();    
})  
}

recordOrderPaymentPending(data,data1){
  this.paymentMode.map(dat=>{
    if(dat.name==data1){
      this.payMode=dat.id;
    }
  })
  var post1 ={
   PaymtAmt: sessionStorage.getItem('PayCost'),
   PaymtMode:this.payMode,
   PaymtRef:data,
   paymtStatus:3
  }     
  this.service.postOrderPaymentDetails(this.payDetails.id,post1).subscribe(res1=>{
   this.handler.res("Payment is Pending!!! ");
   this.complete();    
  })  
  }


complete() { 
  if(this.payDetails.orderType==1){
    var post={
      orderType:1
    }
  } else{
      var post={
        orderType:2
      } 
    }
    this.service.completeOrder(this.payDetails.id,post).subscribe(res => {
      this.handler.loader = false;
      this.handler.res("Order Placed SuccessFully");
      if(localStorage.getItem('orderId')==localStorage.getItem('updateOrderId')){
        localStorage.removeItem('orderId');
        localStorage.removeItem('cateId'); 
        sessionStorage.removeItem('orderValue')
      } 
      if(this.handler.payObj.RESPCODE == "01"){
        this.router.navigate(['/success'])
      }else{
        this.router.navigate(['/pending'])
      }     
    },
      err => {  
        this.handler.err(err);     
      })
     }


// transactionCheck(data){
//   var a = JSON.parse(data.response);
//   console.log(a)
//   var post={
//     ORDERID:a.ORDERID,
//     CHECKSUMHASH:a.CHECKSUMHASH,
//     RESPMSG:a.RESPMSG,
//     STATUS:a.STATUS,
//   }
//   console.log(post)
//   this.service.confirmPayment(post).subscribe(res=>{
//    console.log(res)
//   })
// }

}